import getters from './project/getters'
import mutations from './project/mutations'
import actions from './project/actions'
import { createDefaultState } from './project/state'

export { factory } from './project/state'

export default {
  namespaced: true,
  state: createDefaultState(),
  getters,
  mutations,
  actions,
}
